import * as jQuery from 'jquery';

//MSQQQ : Does not get included otherwise
export function _xxx() {

}

declare global {
    /**  Custom Extensions of JQuery wOut dependencies */
    interface JQuery {
        /** Watch for position/offset changes (Interval cancel handled in interval on DOM remove) */
        onPositionChanged(trigger: Function): JQuery;

        /** Watch for size changes (Interval cancel handled in interval on DOM remove. You can manually cancel with returned function) */
        onSizeChanged(trigger: Function): Function;

        /** Returns the first class of the parameter that is set on the element */
        getFirstMatchedClass(classArray: string[]): string;

        /** Is mouse position inside this element? */
        isMouseInsideContainer(e: JQueryMouseEventObject): boolean;

        /** Max of items.outerWidth(includeMargin=true) */
        GetMaxWidth(): number;

        /**
        * Workaround for clear (x) button on input fields do not trigger change event.
        * Call this function on the "oninput" event on input fields to workaround this issue.
        * Syntax: oninput="$(this).TriggerChangeOnClear()"
        */
        TriggerChangeOnClear(): void;

        /**
        * Ensure (absolute) positioned elements are positioned inside their (anchor-) parents (e.g. (modal)kendoWindow in document)
        */
        fitToOffsetParent(): JQuery;

        /* Wait/sleep as promise */
        wait(time: number): JQueryPromise<{}>;
    }
}
(function ($: JQueryStatic) {
    if (!$)
        return;

    const pollActions = new Array<Function>();
    let pollInterval = 0,
        pollTimeout = 300,
        pollingActive = true;
    window.addEventListener("blur", () => pollingActive = false);
    window.addEventListener("focus", () => pollingActive = true);

    /** register action to call cyclic*/
    function registerPollAction(action: Function) {
        if (pollInterval == 0) {
            pollInterval = window.setInterval(() => {
                if (!pollingActive)
                    return;

                pollActions.forEach(s => {
                    try {
                        s();
                    } catch (err) {
                        console.log(err);
                    }
                });
            }, pollTimeout);
        }

        pollActions.splice(0, 0, action);

        // Return deregistration function
        return () => {
            const idx = pollActions.indexOf(action);
            if (idx >= 0) {
                pollActions.splice(idx, 1);
                if (pollActions.length == 0) {
                    clearInterval(pollInterval);
                    pollInterval = 0;
                }
            }
        };
    }

    $.extend($.fn, {
        // watch for position/offset changes
        onPositionChanged: function (trigger) {
            var o = $(this[0]); // our jquery object
            if (o.length < 1) {
                return o;
            }

            var lastPos = null;
            var lastOff = null;

            var registered = registerPollAction(() => {
                // abort if element is non existend any more
                if (o == null || o.length < 1 || !$.contains(document.documentElement, o[0])) {
                    registered();

                    return o;
                }
                if (lastPos === null) {
                    lastPos = o.position();
                }
                if (lastOff === null) {
                    lastOff = o.offset();
                }
                var newPos = o.position();
                var newOff = o.offset();
                if (lastPos.top != newPos.top || lastPos.left != newPos.left) {
                    $(this).trigger('onPositionChanged', { lastPos: lastPos, newPos: newPos });
                    if (typeof trigger === "function") {
                        trigger(lastPos, newPos);
                    }
                    lastPos = o.position();
                }
                if (lastOff.top != newOff.top || lastOff.left != newOff.left) {
                    $(this).trigger('onOffsetChanged', { lastOff: lastOff, newOff: newOff });
                    if (typeof trigger === "function") {
                        trigger(lastOff, newOff);
                    }
                    lastOff = o.offset();
                }
            });

            return o;
        },

        // watch for size changes
        onSizeChanged: function (trigger, millis = 100) {
            var o = $(this[0]); // our jquery object
            if (o.length < 1) return () => {};

            var lastSize = { width: o.width(), height: o.height() };

            let registered = registerPollAction(() => {
                if (o == null || o.length < 1 || !$.contains(document.documentElement, o[0])) {
                    registered();

                    return 0;
                }

                var newSize = { width: o.width(), height: o.height() };
                if (newSize.width != lastSize.width || newSize.height != lastSize.height) {
                    $(this).trigger('onPositionChanged', { lastSize: lastSize, newSize: newSize });
                    if (typeof (trigger) == "function") trigger(lastSize, newSize);
                    lastSize = newSize;
                }
            });
            return registered;
        },

        isMouseInsideContainer: function (e: JQueryMouseEventObject): boolean {
            if (e) {
                var mousex = e.clientX;
                var mousey = e.clientY;

                var ppos = $(this).position();
                var boundsLeft = ppos.left;
                var boundsRight = ppos.left + $(this).width();
                var boundsTop = ppos.top;
                var boundsBottom = ppos.top + $(this).height();

                var isInsideWindow = mousex >= boundsLeft && mousex <= boundsRight &&
                    mousey >= boundsTop && mousey <= boundsBottom;

                return isInsideWindow;
            }

            return false;
        },

        getFirstMatchedClass: function (selectors) {
            var self = this;
            for (var i in selectors) {
                if ($(self).hasClass(selectors[i]))
                    return selectors[i];
            }
            return selectors[i];
        },

        GetMaxWidth: function () {
            return Math.max.apply(Math, this.map(function () { return $(this).outerWidth(true); }).get());
        },

        TriggerChangeOnClear: function () {
            this.each(function () {
                if (this instanceof HTMLInputElement && !this.value) {
                    $(this).trigger("change");
                }
            });
        },

        /**
        * Ensure (absolute) positioned elements are positioned inside their (anchor-) parents (e.g. (modal)kendoWindow in document)
        */
        fitToOffsetParent: function () {
            this.each(function () {
                var inner = <JQuery>$(this),
                    outer = inner.offsetParent();
                if (!(inner.length && outer && outer.length))
                    return;

                var outerSize = { width: outer.innerWidth(), height: outer.innerHeight() };
                var innerSize = { width: inner.outerWidth(), height: inner.outerHeight() };
                var margin = { width: innerSize.width - inner.width(), height: innerSize.height - inner.height() };
                var windowPos = inner.offset();
                var isOverWidth = innerSize.width > outerSize.width;
                var isOverHeight = innerSize.height > outerSize.height;
                var isCutoffWidth = innerSize.width + windowPos.left > outerSize.width;
                var isCutoffHeight = innerSize.height + windowPos.top > outerSize.height;

                // Adapt position?
                if (isCutoffWidth || isCutoffHeight) {
                    var newOffset = <JQueryCoordinates>{
                        top: isCutoffHeight ?
                            Math.max(0, outerSize.height - innerSize.height) : windowPos.top,
                        left: isCutoffWidth ?
                            Math.max(0, outerSize.width - innerSize.width) : windowPos.left
                    };
                    inner.offset(newOffset);
                }

                // Adapt width?
                if (isOverWidth) {
                    inner.width(outerSize.width - margin.width);
                }

                // Adapt height?
                if (isOverHeight) {
                    inner.height(outerSize.height - margin.height);
                }
            });
            return this;
        },

        /* Wait/sleep as promise */
        wait: function (time: number) {
            return $.Deferred(function (dfd) {
                setTimeout(dfd.resolve, time);
            }).promise();
        }
    });
})(<JQueryStatic><any>jQuery);
